import RestService from "./RestService";


export default class MyVolumeService extends RestService {
    constructor() {
        super('/api/myvolume');
    }
}
